"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _WalletRowComponent = _interopRequireDefault(require("./WalletRowComponent"));
var _productPositionSelectors = require("../../redux/selectors/productPositionSelectors");
var _positionActions = require("../../redux/actions/positionActions");
var _resize = _interopRequireDefault(require("../../hocs/resize"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _getProductByIdSelect = (0, _productPositionSelectors.getProductByIdSelector)(state, ownProps.productId),
    iconFileName = _getProductByIdSelect.iconFileName,
    ProductSymbol = _getProductByIdSelect.ProductSymbol,
    ProductFullName = _getProductByIdSelect.ProductFullName,
    ProductType = _getProductByIdSelect.ProductType,
    ProductId = _getProductByIdSelect.ProductId,
    isWithdrawAllowed = _getProductByIdSelect.DepositEnabled,
    isDepositAllowed = _getProductByIdSelect.WithdrawEnabled;
  var isCrypto = ProductType === 'CryptoCurrency';
  return {
    iconFileName: iconFileName,
    ProductSymbol: ProductSymbol,
    ProductFullName: ProductFullName,
    isCrypto: isCrypto,
    ProductId: ProductId,
    detailsLink: ownProps.detailsLink,
    isWithdrawAllowed: isWithdrawAllowed,
    isDepositAllowed: isDepositAllowed
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    selectPositionAndSave: function selectPositionAndSave() {
      dispatch((0, _positionActions.selectPositionAndSave)(ownProps.productId));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _resize["default"])(_WalletRowComponent["default"]));